export default class ExportsListviewController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
    }

    $onInit() {

    }

    getFileTypeStringForRow(row) {
        if (!row.export_file) {
            return '';
        }

        let out = '';
        switch (row.export_file.mime) {
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                out += 'XLSX';
                break;
            case 'application/pdf':
                out += 'PDF';
                break;
            case 'text/csv':
                out += 'CSV';
                break;
            case 'application/zip':
                out += 'ZIP';
                break;
        }

        return out ? 'as ' + out : '';
    }

    getFileTypeIconForRow(row) {
        if (!row.export_file) {
            return '';
        }

        let out = 'file-alt';
        switch (row.export_file.mime) {
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                out = 'file-excel';
                break;
            case 'application/pdf':
                out = 'file-pdf';
                break;
            case 'text/csv':
                out = 'file-csv';
                break;
            case 'application/zip':
                out = 'file-archive';
                break;
        }

        return out;
    }

    getTimeFieldForStatus(row) {
        if (!row.status) {
            return '';
        }

        switch (row.status) {
            case 'running':
                return row.started_at;
            case 'failed':
                return row.failed_at;
            case 'finished':
                return row.started_at;
            case 'scheduled':
            case 'unknown':
                return row.created_at;
        }

        return null;
    }

    getTimeLabelForStatus(row) {
        if (!row.status) {
            return '';
        }

        switch (row.status) {
            case 'running':
                return 'Started at';
            case 'failed':
                return 'Failed at';
            case 'finished':
                return 'Finished at';
            case 'scheduled':
            case 'unknown':
                return 'Scheduled at';
        }

        return null;
    }
}

ExportsListviewController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/components/state-manager/listview/exports-table/controller.js